import { keyframes } from '@emotion/react';

export const slideInLeft = keyframes`
    from {
        transform: translate3d(-100%, 0, 0);
        visibility: visible;
    }
    
    to {
        transform: translate3d(0, 0, 0);
    }
`;

export const slideOutLeft = keyframes`
    from {
        transform: translate3d(0, 0, 0);
    }
    
    to {
        visibility: hidden;
        transform: translate3d(-100%, 0, 0);
    }
`;

export const slideInUp = keyframes`
    from {
        opacity: 0%;
        transform: translate3d(0, 20%, 0);
        visibility: visible;
    }
    
    to {
        opacity:100%;
        transform: translate3d(0, 0, 0);
    }
`;

export const slideInDown = keyframes`
    from {
        opacity: 0%;
        transform: translate3d(0, -20%, 0);
        visibility: visible;
    }
    
    to {
        opacity:100%;
        transform: translate3d(0, 0, 0);
    }
`;

export const fadeIn = keyframes`
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
`;

export const fadeOut = keyframes`
    from {
        opacity: 1;
    }

    to {
        opacity: 0;
    }
`;

export const fadeInDown = keyframes`
    from {
        opacity: 0;
        transform: translateY(-20px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
`;

export const jackInTheBox = keyframes`
    from {
        opacity: 0;
        transform: scale(0.1) rotate(30deg);
        transform-origin: center bottom;
    }
    
    50% {
        transform: rotate(-10deg);
    }
    
    70% {
        transform: rotate(3deg);
    }
    
    to {
        opacity: 1;
        transform: scale(1);
    }
`;
